<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Filter />

    <div class="container">
      <div class="row px-3 py-4">
        <div class="col-md-2">
          <div class="form-group">
            <label class="custom-label">Schema</label>
            <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
              id="autoSizingSelect" v-model="Schema">
              <option value="" disabled selected>Select Option</option>
              <option v-for="schema in schemaOptions" :key="schema" :value="schema">{{ schema }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-7 "
          :class="{ 'mb-2': selectedSensorOptions.length === 0 || maxSensorsMessage, 'mb-3': selectedSensorOptions.length > 0 }">
          <div class="form-group" :class="{ 'mb-1': selectedSensorOptions.length > 0 }">
            <label class="custom-label">Select Sensors - Show on Columns</label>
            <div class="custom-multiple-dropdown-wrapper">
              <select class="form-select-sm form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                v-model="column_dimention">
                <option value="" disabled selected>Select Option</option> <!-- Placeholder option -->
                <option v-for="sensor in sensorOptions" :key="sensor.name" :value="sensor.name">{{ sensor.name }}
                </option>
              </select>
              <button @click="updateSelectedSensor(column_dimention)" class="multiple-dropdown-add-button">+</button>
            </div>
          </div>

          <div class="col-md-12 align-self-end custom-input">
            <div v-if="selectedSensorOptions.length > 0" class="custom-multiple-dropdown-container">
              <div v-for="(sensor, index) in selectedSensorOptions" :key="index">
                <span class="custom-multiple-dropdown">{{ sensor.name }}
                  <button class="multiple-dropdown-delete-icon" @click="removeSelectedSensor(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <small v-if="selectedSensorOptions.length === 0" class="text-danger"
            style="margin-top: -10px; font-size: 11px;">Select Sensor</small>
          <small v-if="maxSensorsMessage" class="text-danger" style="margin-top: -10px; font-size: 11px;">
            {{ maxSensorsMessage }}
          </small>


        </div>
        <div class="col-md-3 "
          :class="{ 'mb-2': selectedTimeRangeOptions.length === 0 || maxTimeRangeMessage, 'mb-3': selectedTimeRangeOptions.length > 0 }">
          <div class="form-group" :class="{ 'mb-1': selectedTimeRangeOptions.length > 0 }">
            <label class="custom-label">Select Months - Show on Rows</label>
            <div class="custom-multiple-dropdown-wrapper">
              <select class="form-select-sm form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                v-model="row_dimention">
                <option value="" disabled selected>Select Option</option> <!-- Placeholder option -->
                <option v-for="time in timeRangeOptions" :key="time.date" :value="time.date">{{ time.month }}</option>
              </select>
              <button @click="updateSelectedTimeRange(row_dimention)" class="multiple-dropdown-add-button">+</button>
            </div>
          </div>

          <div class="col-md-12 align-self-end custom-input">
            <div v-if="selectedTimeRangeOptions.length > 0" class="custom-multiple-dropdown-container">
              <div v-for="(time, index) in selectedTimeRangeOptions" :key="index">
                <span class="custom-multiple-dropdown">{{ time.month }}
                  <button class="multiple-dropdown-delete-icon" @click="removeSelectedTimeRange(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <small v-if="selectedTimeRangeOptions.length === 0" class="text-danger"
            style="margin-top: -10px; font-size: 11px;">Select Time/Month</small>
          <small v-if="maxTimeRangeMessage" class="text-danger" style="margin-top: -10px; font-size: 11px;">
            {{ maxTimeRangeMessage }}
          </small>
        </div>
        <div class="col-md-6 mt-4">
          <div class="form-check form-check-inline me-4">
            <input class="form-check-input shadow-none" type="checkbox" value="" id="defaultCheck1"
              v-model="isDeviceChecked">
            <label class="form-check-label custom-label" for="defaultCheck1">
              Show Device Hubs
            </label>
          </div>

          <div class="form-check form-check-inline ">
            <input class="form-check-input shadow-none" type="checkbox" value="" id="defaultCheck1"
              v-model="isShowOpTempRangeChecked">
            <label class="form-check-label custom-label" for="defaultCheck1">
              Show OP Temp Ranges
            </label>
          </div>

          <div class="form-check form-check-inline ms-2">
            <input class="form-check-input shadow-none" type="checkbox" value="" id="defaultCheck1"
              v-model="isMultResSetChecked">
            <label class="form-check-label custom-label" for="defaultCheck1">
              Show Multiple Results Sets
            </label>
          </div>
        </div>

        <!-- <div class="col-md-3 " :class="{'mb-2': selectedDeviceOptions.length === 0 || maxDeviceMessage, 'mb-3': selectedDeviceOptions.length > 0}">
          <div class="form-group" :class="{'mb-1': selectedDeviceOptions.length>0}">
            <label class="custom-label">Device</label>
            <div class="custom-multiple-dropdown-wrapper">
              <select :disabled="!isDeviceChecked" class="form-select-sm form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                v-model="device">
                <option value="" disabled selected>Select Option</option> 
                <option v-for="device in deviceOptions" :key="device.uuid" :value="device.uuid">{{ device.name }}</option>
              </select>
              <button @click="updateSelectedDevice(device)" class="multiple-dropdown-add-button">+</button>
            </div>
          </div>

        <div class="col-md-12 align-self-end custom-input">
          <div v-if="selectedDeviceOptions.length > 0" class="custom-multiple-dropdown-container">
            <div v-for="(device, index) in selectedDeviceOptions" :key="index">
              <span class="custom-multiple-dropdown">{{ device.name }}
                <button class="multiple-dropdown-delete-icon" @click="removeSelectedDevice(index)">
                  <dropdownDeleteIcon />
                </button>
              </span>
            </div>
          </div>
        </div>
        <small v-if="selectedDeviceOptions.length === 0" class="text-danger"
          style="margin-top: -10px; font-size: 11px;">Select Device</small>
          <small v-if="maxDeviceMessage" class="text-danger" style="margin-top: -10px; font-size: 11px;">
          {{ maxDeviceMessage }}
       </small>
        </div>           -->
        <div class="col-md-6" :class="{ 'mb-2': selectedParameterOptions.length > 0 }">
          <div class="form-group" :class="{ 'mb-1': selectedParameterOptions.length > 0 }">
            <label class="custom-label">Data Warehouse Facts</label>
            <div class="custom-multiple-dropdown-wrapper">
              <select class="form-select-sm form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                v-model="facts">
                <option value="" disabled selected>Select Option</option> <!-- Placeholder option -->
                <option v-for="parameter in parameterOptions" :key="parameter.uuid" :value="parameter.uuid">{{
                  parameter.name }}</option>
              </select>
              <button @click="updateSelectedParameter(facts)" class="multiple-dropdown-add-button">+</button>
            </div>
          </div>

          <div class="col-md-12 align-self-end custom-input">
            <div v-if="selectedParameterOptions.length > 0" class="custom-multiple-dropdown-container">
              <div v-for="(parameter, index) in selectedParameterOptions" :key="index">
                <span class="custom-multiple-dropdown">{{ parameter.name }}
                  <button class="multiple-dropdown-delete-icon" @click="removeSelectedParameter(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <small v-if="selectedParameterOptions.length === 0" class="text-danger"
            style="margin-top: -10px; font-size: 11px;">Select Parameter</small>

        </div>
        <div class="form-group ">
          <button class="btn btn-sm btn-primary filter-button" type="button" @click="fetchLakeHouseData" :disabled="!this.Schema || selectedTimeRangeOptions.length === 0 ||
            selectedSensorOptions.length === 0 || selectedParameterOptions.length === 0">Submit</button>
        </div>
      </div>

      <div v-for="(indexx, idx) in Object.keys(tableDataList).map(Number).sort((a, b) => b - a).slice(0, 6)"
        :key="indexx">

        <div class="row px-3" v-for="(data, index) in tableDataList[indexx]" :key="index">

          <div class="col-md-12 overflow-y-auto">
            <label v-if="isMultipleResultsSetActive" class="mb-2 custom-label"><strong>Result Set {{ idx + 1 }}</strong>
            </label>
            <table class="table table-bordered table-hover table-responsive">
              <thead>
                <tr>
                  <th rowspan="3" class="align-middle text-center dateColColor">Time</th>
                  <!-- First Row: Hub Names -->
                  <template v-if="hubVisibility[indexx]">
                    <template v-for="(hubData, hubName) in data" :key="hubName">
                      <th class="hubColColor text-center" :colspan="getSensorColumnCount(hubData, indexx)">
                        Hub: {{ hubName }}
                      </th>
                    </template>
                  </template>
                </tr>
                <tr>
                  <!-- Second Row: Sensor Names -->
                  <template v-if="hubVisibility[indexx]">
                    <template v-for="hubData in data" :key="hubData">
                      <template v-for="(sensorData, sensorName) in hubData" :key="sensorName">

                        <th class="sensorColColor text-center" :colspan="visibleFields[indexx].length">Sensor:
                          {{ sensorName }}
                          <span v-if="opTempVisibility[indexx] && (sensorData[0].optemp === 'high' || sensorData[0].optemp === 'low'
                            || sensorData[0].optemp === 'medium'
                          )"> ,</span> <br>
                          <span v-if="opTempVisibility[indexx] && sensorData[0].optemp === 'high'"> Hi Temp (150&deg;C - 300&deg;C)</span>
                          <span v-else-if="opTempVisibility[indexx] && sensorData[0].optemp === 'medium'"> Med Temp (80&deg;C - 150&deg;C)</span>
                          <span v-else-if="opTempVisibility[indexx] && sensorData[0].optemp === 'low'"> Lo Temp (0&deg;C - 80&deg;C)</span>
                        </th>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <!-- <template v-for="(sensorData, sensorName) in flattenedSensors" :key="sensorName"> -->
                    <template v-for="hubData in data" :key="hubData">
                      <template v-for="(sensorData, sensorName) in hubData" :key="sensorName">
                        <th class="sensorColColor text-center" :colspan="visibleFields[indexx].length">Sensor: {{
                          sensorName }}
                           <span v-if="opTempVisibility[indexx] && (sensorData[0].optemp === 'high' || sensorData[0].optemp === 'low'
                            || sensorData[0].optemp === 'medium'
                          )"> ,</span> <br>
                          <span v-if="opTempVisibility[indexx] && sensorData[0].optemp === 'high'"> Hi Temp (150&deg;C - 300&deg;C)</span>
                          <span v-else-if="opTempVisibility[indexx] && sensorData[0].optemp === 'medium'"> Med Temp (80&deg;C - 150&deg;C)</span>
                          <span v-else-if="opTempVisibility[indexx] && sensorData[0].optemp === 'low'"> Lo Temp (0&deg;C - 80&deg;C)</span>
                        </th>
                      </template>
                    </template>

                  </template>
                </tr>
                <tr>
                  <!-- Third Row: Dynamic Headers -->
                  <template v-if="hubVisibility[indexx]">
                    <template v-for="hubData in data" :key="hubData">
                      <template v-for="(sensorData, sensorName) in hubData" :key="sensorName">
                        <template v-for="field in visibleFields[indexx]" :key="field">
                          <th class="align-top text-center">{{ fieldLabels[field] }}</th>
                        </template>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <!-- <template v-for="sensorName in Object.keys(flattenedSensors)" :key="sensorName"> -->
                    <template v-for="hubData in data" :key="hubData">
                      <template v-for="(sensorData, sensorName) in hubData" :key="sensorName">
                        <template v-for="field in visibleFields[indexx]" :key="field">
                          <th class="align-top text-center">{{ fieldLabels[field] }}</th>
                        </template>
                      </template>
                    </template>
                  </template>
                  <!-- </template> -->
                </tr>
              </thead>

              <tbody>
                <template v-for="(date, dateindex) in uniqueDates[indexx]" :key="dateindex">
                  <tr>
                    <!-- {{ date, dateindex }} -->
                    <!-- Display the Date -->
                    <td class="dateColColor text-center">{{ new Date(date).toLocaleDateString("en-US", {
                      month: "long"
                    }) }}</td>
                    <!-- Iterate through hubs and sensors for the current date -->
                    <template v-for="(hubData, hubName) in data" :key="hubName">
                      <template v-for="(sensorData, sensorName) in hubData" :key="sensorName">
                        <!-- Find the entry for the current date -->
                        <template v-if="getSensorDataForDate(sensorData, date)">
                          <template v-for="field in visibleFields[indexx]" :key="field">
                            <td class="text-center">{{ getSensorDataForDate(sensorData, date)[field] }}</td>
                          </template>
                        </template>
                        <!-- If no data for the current date, display empty cells -->
                        <template v-else>
                          <td v-for="field in visibleFields[indexx]" :key="field"></td>
                        </template>
                      </template>
                    </template>
                  </tr>
                </template>
              </tbody>
            </table>

          </div>
        </div>
        <!-- <div v-else-if="isTableVisible && Object.keys(tableData).length === 0">
    <p class="text-center text-muted mt-4">No record found</p>
  </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import dropdownDeleteIcon from '@/components/dropdown-delete-icon.vue';
import { ddLakeHouseSensor, ddLakeHouseParameter, getLakeHouse, ddLakeHouseDevice, ddLakeHouseTime } from '@/http/dashboard/lakehouse.http'
export default {
  name: 'lakehouse',
  components: {
    Header,
    Filter,
    dropdownDeleteIcon
  },
  data() {
    return {
      breadcrumsfirst: "Dashboard",
      breadcrumslast: "Lake House",
      timeRangeOptions: [],
      selectedTimeRangeOptions: [],
      column_dimention: '',
      schemaOptions: ["Sensor Performance"],
      parameterOptions: [],
      selectedParameterOptions: [],
      facts: '',
      sensorOptions: [],
      selectedSensorOptions: [],
      row_dimention: '',
      Schema: '',
      deviceOptions: [],
      selectedDeviceOptions: [],
      device: '',
      isTableVisible: false,
      fields: {},
      dates: {},
      // confirmedTimeDimension: '',
      maxSensorsMessage: '',
      maxTimeRangeMessage: '',
      maxDeviceMessage: '',
      isDeviceChecked: 0,
      confirmDeviceChecked: 0,
      isShowOpTempRangeChecked: 0,
      confirmShowOpTempRangeChecked: 0,
      isMultResSetChecked: 0,
      // tableDataList: [], 
      tableDataList: {},
      iterationCount: 0,
      opTempVisibility: [],
      hubVisibility: [],
      isMultipleResultsSetActive: false,

    }
  },
  computed: {
    // flattenedSensors() {
    //   const sensors = {};
    //   for (const tableData of this.tableDataList[this.iterationCount]) {
    //     for (const hubData of Object.values(tableData)) {
    //       for (const [sensorName, sensorData] of Object.entries(hubData)) {
    //         sensors[sensorName] = sensorData;
    //       }
    //     }
    //   }
    //   return sensors;
    // },
    uniqueDates() {
  for (const tableData of this.tableDataList[this.iterationCount]) {
    for (const hubData of Object.values(tableData)) {
      for (const sensorData of Object.values(hubData)) {
        sensorData.forEach((entry) => {
          if (this.dates[this.iterationCount]) {
            if (!this.dates[this.iterationCount].includes(entry.date)) {
              this.dates[this.iterationCount].push(entry.date);
            }
          } else {
            this.dates[this.iterationCount] = [entry.date];
          }
        });
      }
    }
  }

  if (this.dates[this.iterationCount]) {
    this.dates[this.iterationCount].sort((a, b) => new Date(b) - new Date(a));
  }

  return this.dates;
},
    visibleFields() {
      // const fields = new Set();
      for (const tableData of this.tableDataList[this.iterationCount]) {
        for (const hubData of Object.values(tableData)) {
          for (const sensorData of Object.values(hubData)) {
            sensorData.forEach((entry) => {
              Object.keys(entry).forEach((key) => {
                if (key !== 'date' && key !== 'hub' && key !== 'sensorname' && key !== 'optemp') {
                  if (this.fields[this.iterationCount]) {
                    if (!this.fields[this.iterationCount].includes(key)) {
                      this.fields[this.iterationCount].push(key);
                    }
                  } else {
                    this.fields[this.iterationCount] = [key]
                  }
                }
              })

            });
          }
        }
      }

      // return Array.from(fields);
      return this.fields;
    },
    fieldLabels() {
      return {
        uptime: 'Up Time',
        downtime: 'Down Time',
        total_alarms: 'No. of Alarms',
        autoresolved_alarms: 'No. of Auto Resolved',
        manualresolved_alarms: 'No. of Manual Resolved',
        unresolved_alarms: 'Unresolved Alarms',
        max: 'Max Value',
        min: 'Min Value',
        mean : 'Mean Value'
      };
    },
  },

  mounted() {
    this.fetchDDLakeHouseSensor();
    this.fetchDDLakeHouseParameter();
    this.fetchDDLakeHouseTime();
  },
  methods: {
    fetchLakeHouseData() {
      const payload = {
        Schema: this.Schema,
        row_dimention: this.selectedTimeRangeOptions.map(option => option.date).join(","),
        column_dimention: this.selectedSensorOptions.map(option => option.name).join(","),
        device: this.selectedDeviceOptions.map(option => option.uuid).join(","),
        facts: this.selectedParameterOptions.map(option => option.uuid).join(","),
        isoptemp: this.isShowOpTempRangeChecked ? 1 : 0,
      };
      getLakeHouse(payload)
        .then((response) => {
          if (this.isMultResSetChecked) {
            this.isMultipleResultsSetActive = true;
            this.iterationCount += 1;
            this.tableDataList[this.iterationCount] = [response]
            this.opTempVisibility[this.iterationCount] = this.isShowOpTempRangeChecked; 
            this.hubVisibility[this.iterationCount] = this.isDeviceChecked;
            // Convert tableDataList keys to an array and sort in descending order
            let keys = Object.keys(this.tableDataList).map(Number).sort((a, b) => b - a);

            // If we exceed 6 entries, remove the oldest one
            if (keys.length > 6) {
              delete this.tableDataList[keys[keys.length - 1]]; // Remove the oldest (smallest key)
            }


            this.isTableVisible = true;
            // this.confirmedTimeDimension = this.row_dimention;
            this.confirmDeviceChecked = this.isDeviceChecked;
            this.confirmShowOpTempRangeChecked = this.isShowOpTempRangeChecked
          } else {
            this.isMultipleResultsSetActive = false;
            this.tableDataList = {};
            this.iterationCount += 1;
            this.tableDataList[this.iterationCount] = [response]
            this.opTempVisibility[this.iterationCount] = this.isShowOpTempRangeChecked; 
            this.hubVisibility[this.iterationCount] = this.isDeviceChecked;
            // Convert tableDataList keys to an array and sort in descending order
            let keys = Object.keys(this.tableDataList).map(Number).sort((a, b) => b - a);

            // If we exceed 6 entries, remove the oldest one
            if (keys.length > 6) {
              delete this.tableDataList[keys[keys.length - 1]]; // Remove the oldest (smallest key)
            }


            this.isTableVisible = true;
            // this.confirmedTimeDimension = this.row_dimention;
            this.confirmDeviceChecked = this.isDeviceChecked;
            this.confirmShowOpTempRangeChecked = this.isShowOpTempRangeChecked
          }

        }).catch(error => {
          console.error("Error fetching data:", error);
          this.isTableVisible = false;

        })

    },
    async fetchDDLakeHouseSensor() {
      try {
        this.sensorOptions = await ddLakeHouseSensor();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDDLakeHouseTime() {
      try {
        this.timeRangeOptions = await ddLakeHouseTime();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDDLakeHouseDevice() {
      try {
        const payload = {
          sensorname: this.selectedSensorOptions.map(option => option.name).join(","),
        };

        this.deviceOptions = await ddLakeHouseDevice(payload);
        this.selectedDeviceOptions = [];
        this.deviceOptions.forEach(device => {
          this.selectedDeviceOptions.push({ uuid: device.uuid, name: device.name });
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDDLakeHouseParameter() {
      try {
        this.parameterOptions = await ddLakeHouseParameter();
      } catch (error) {
        console.error('Error fetching data :', error);
      }
    },
    updateSelectedSensor(column_dimention) {
      if (this.selectedSensorOptions.length >= 3) {
        this.maxSensorsMessage = 'You can select a maximum of 3 sensors.';
        return;
      } else {
        this.maxSensorsMessage = ''; // Clear the message if the limit is not reached
      }

      const sensor = this.sensorOptions.find(sensor => sensor.name === column_dimention);
      if (sensor && !this.selectedSensorOptions.some(s => s.name === sensor.name)) {
        this.selectedSensorOptions.push({ name: sensor.name });
      }
    },

    updateSelectedTimeRange(row_dimention) {
      if (this.selectedTimeRangeOptions.length >= 3) {
        this.maxTimeRangeMessage = 'You can select a maximum of 3 Months.';
        return;
      } else {
        this.maxTimeRangeMessage = ''; // Clear the message if the limit is not reached
      }

      const time = this.timeRangeOptions.find(time => time.date === row_dimention);
      if (time && !this.selectedTimeRangeOptions.some(t => t.date === time.date)) {
        this.selectedTimeRangeOptions.push({ date: time.date, month: time.month });
      }
    },
    // updateSelectedDevice(device1) {
    //   if (this.selectedDeviceOptions.length >= 3) {
    //     this.maxDeviceMessage = 'You can select a maximum of 3 Months.';
    //     return;
    //   } else {
    //     this.maxDeviceMessage = ''; // Clear the message if the limit is not reached
    //   }

    //   const device = this.deviceOptions.find(device => device.uuid === device1);
    //   if (device && !this.selectedDeviceOptions.some(p => p.uuid === device.uuid)) {
    //     this.selectedDeviceOptions.push({ uuid: device.uuid, name: device.name });
    //   }
    // },

    updateSelectedParameter(facts) {
      const parameter = this.parameterOptions.find(parameter => parameter.uuid === facts);
      if (parameter && !this.selectedParameterOptions.some(p => p.uuid === parameter.uuid)) {
        this.selectedParameterOptions.push({ uuid: parameter.uuid, name: parameter.name });
      }
    },

    removeSelectedTimeRange(index) {
      this.selectedTimeRangeOptions.splice(index, 1);
      if (this.selectedTimeRangeOptions.length < 3) {
        this.maxTimeRangeMessage = '';
      }
    },
    removeSelectedSensor(index) {
      this.selectedSensorOptions.splice(index, 1);
      if (this.selectedSensorOptions.length < 3) {
        this.maxSensorsMessage = '';
      }
    },
    //   removeSelectedDevice(index) {
    //     this.selectedDeviceOptions.splice(index, 1);
    //     if (this.selectedDeviceOptions.length < 3) {
    //   this.maxDeviceMessage = '';
    // }
    //   },
    removeSelectedParameter(index) {
      this.selectedParameterOptions.splice(index, 1);

    },
    getSensorDataForDate(sensorData, date) {
      return sensorData.find((entry) => entry.date === date) || null;
    },
    getSensorColumnCount(hubData, indexx) {
      return Object.keys(hubData).length * this.visibleFields[indexx].length;
    },
    toggleOpTempRanges() {
    this.opTempVisibility[this.iterationCount] = !this.opTempVisibility[this.iterationCount];
    },
    toggleDeviceHubs() {
    this.hubVisibility[this.iterationCount] = !this.hubVisibility[this.iterationCount];
    }


    //   formatDateLabel(date) {
    //   const parsedDate = new Date(date);
    //   if (this.confirmedTimeDimension === "week") {
    //     // Format: Jan 1, Jan 2
    //     return parsedDate.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    //   } else if (this.confirmedTimeDimension === "month") {
    //     // Format: Week 1, Week 2
    //     const weekNumber = Math.ceil(parsedDate.getDate() / 7);
    //     return `Week ${weekNumber}`;
    //   } else if (this.confirmedTimeDimension === "year-h1" || this.confirmedTimeDimension === "year-h2") {
    //     // Format: Jan, Feb
    //     return parsedDate.toLocaleDateString("en-US", { month: "short" });
    //   } else {
    //     // Default format: full date
    //     return parsedDate.toLocaleDateString();
    //   }
    // },
  },
  watch: {
    // Watch the 'isDeviceChecked' flag to make sure we call the API only when it's checked
    isDeviceChecked(newValue) {
      if (newValue && this.selectedSensorOptions.length > 0) {
        this.fetchDDLakeHouseDevice(); // Call API if device is checked and sensors are selected
      } else {
        this.selectedDeviceOptions = []; // Clear device options when device hub is unchecked
        this.device = '';
      }
    },
    // Watch changes in 'selectedSensorOptions' and call API if conditions are met
    selectedSensorOptions: {
      handler(newValue) {
        if (this.isDeviceChecked && newValue.length > 0) {
          this.fetchDDLakeHouseDevice(); // Call API if show device hub is checked
        }
      },
      deep: true, // Ensure the watcher works for added/removed elements
    },
  },


}
</script>




<style scoped>
.dateColColor {
  background-color: rgba(207, 226, 255, 0.250) !important;
}

.sensorColColor {
  background-color: rgba(255, 243, 205, 0.250) !important;
}

.hubColColor {
  background-color: rgba(161, 227, 230, 0.2) !important;
}

.col-md-2-5 {
  flex: 0 0 57%;
  /* 20% of the container width */
  max-width: 57%;
}
</style>